import React from "react";
import {Link} from "react-router-dom";
import Picture from "../Components/Picture/Picture";
import {PictureProps} from "../Components/Picture/PictureProps";
import TitleTag from "../Components/TitleTag";

export interface AanbiedingPageProps {
    pageTitle: string;
    pageDescription: string;
    pageCanonical: string;
    headerPicture: PictureProps;
    title: string;
}

const AanbiedingPage: React.FC<AanbiedingPageProps> = (
    props: AanbiedingPageProps
) => {
    return (
        <>
            <TitleTag
                title={props.pageTitle}
                description={props.pageDescription}
                canonical={props.pageCanonical}
                date="01-10-2021"
            />
            <div className="w-full relative">
                <Picture imageClass="w-full" {...props.headerPicture} />
                <div className="absolute bottom-0 left-0 flex p-4 bg-lightviolet w-full">
                    <h1 className="text-4xl pt-4 sm:text-3xl md:text-5xl m-2 font-Primary text-white font-normal">
                        {props.title}
                    </h1>
                </div>
            </div>
            <div className="bg-grey">
                <section className="container ml-auto mr-auto p-4">
                    <h2>Ribeskin carboxy therapy</h2>
                    <p>Carboxy staat voor kooldioxide, een onzichtbaar en geurloos gas welke in de lucht zit en we inademen. Tevens komt het in ons eigen lichaam vrij bij verbrandingsprocessen tijdens de stofwisseling. Onze revolutionaire CO2-carboxytherapie helpt het metabolisme van de huid te versnellen en de natuurlijke productie van zuurstof te stimuleren, het verbeterd de huid-elasticiteit, zorgt voor een diepe hydratie en verfijnt de poriestructuur.<br/>
                    De huid ziet er na 1 behandeling aanzienlijk helderder, frisser, egaler, minder gelijnd en soepel uit.&nbsp;
                        <strong>Nu voor 104,95 euro</strong></p>
                    <ul>
                        <li>reiniging</li>
                        <li>Carboxy Masker</li>
                        <li>hydraterend vliesmasker onder de Beauty Angel créme</li>
                        

                    </ul>
                </section>
            </div>
        </>
    );
};

export default AanbiedingPage;
